import { render, staticRenderFns } from "./cbzj.vue?vue&type=template&id=6ea46d20&scoped=true&"
import script from "./cbzj.vue?vue&type=script&lang=js&"
export * from "./cbzj.vue?vue&type=script&lang=js&"
import style0 from "./cbzj.vue?vue&type=style&index=0&id=6ea46d20&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ea46d20",
  null
  
)

export default component.exports